import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import ContourBackground from "@/components/ContourBackground";

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "";

/** Blog article card; `featured` renders the large lead variant. */
export default function PostCard({ post, featured = false }) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      data-testid={`blog-card-${post.slug}`}
      className={`group relative overflow-hidden flex flex-col justify-between border border-slate-200 bg-white hover:border-topo transition-colors duration-200 ${
        featured ? "p-8 lg:p-10 min-h-[320px]" : "p-6 min-h-[240px]"
      }`}
    >
      {featured && <ContourBackground variant="light" opacity={0.5} seed={post.slug.length} />}
      <div className="relative">
        <div className="flex items-center justify-between gap-3">
          <span className="mono text-[10px] tracking-[0.22em] uppercase text-orange-survey">{post.category}</span>
          <ArrowUpRight className="h-4 w-4 text-slate-400 group-hover:text-topo group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" />
        </div>
        <h3
          className={`display mt-3 font-extrabold tracking-tight text-slate-900 group-hover:text-topo transition-colors ${
            featured ? "text-2xl sm:text-3xl lg:text-4xl leading-[1.1]" : "text-lg leading-snug"
          }`}
        >
          {post.title}
        </h3>
        <p className={`mt-3 text-slate-600 leading-relaxed ${featured ? "text-base max-w-2xl" : "text-sm line-clamp-3"}`}>{post.excerpt}</p>
      </div>
      <div className="relative mt-6 flex items-center gap-3 mono text-[10px] tracking-[0.18em] uppercase text-slate-500">
        <span>{fmtDate(post.published_at)}</span>
        <span className="h-1 w-1 rounded-full bg-slate-300" />
        <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3" /> {post.read_minutes} min read</span>
      </div>
    </Link>
  );
}
